/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alive_Mad_Beaver_PauseInputs */

const fr_alive_mad_beaver_pause = /** @type {(inputs: Alive_Mad_Beaver_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

/**

* @param {Alive_Mad_Beaver_PauseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const alive_mad_beaver_pause = /** @type {((inputs?: Alive_Mad_Beaver_PauseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alive_Mad_Beaver_PauseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_alive_mad_beaver_pause(inputs)
});